import { ObsessedEngineeringProductVersion } from './obsessed-engineering-product-version.model';

export interface ObsessedEngineeringProduct {
    id: string;
    qtyOnHand: number;
}

export type DisplayObsessedEngineeringProduct = ObsessedEngineeringProduct
    & Omit<ObsessedEngineeringProductVersion, 'id' | 'productId'>
    & { productVersionId: string };

export function toDisplayObsessedEngineeringProducts(
    products: ObsessedEngineeringProduct[],
    productVersions: ObsessedEngineeringProductVersion[],
): DisplayObsessedEngineeringProduct[] {
    const productById = Object.fromEntries(products.map((product) => [product.id, product]));

    return productVersions.flatMap((productVersion) => {
        const product = productById[productVersion.productId];
        if (!product) return [];

        return [{
            ...productVersion,
            ...product,
            productVersionId: productVersion.id,
        }];
    });
}
